<template>
    <div
        class="md-hero layout14 mg-bg"
        :class="[
            isVideoPlay &&
                videoOption &&
                (videoOption.autoplay || videoOption.playInline)
                ? 'video-in-play'
                : ''
        ]"
        :style="{
            ...colorStyle,
            ...spaceStyle
        }"
    >
        <banner
            ref="banner"
            :type="type"
            :mobileType="mobileType"
            :useMobileSettings="useMobileSettings"
            :sizeOption="sizeOption"
            :pictureOption="pictureOption"
            :mobilePicture="mobilePicture"
            :maskOption="maskOption"
            :videoOption="videoOption"
            :mobileVideoOption="mobileVideoOption"
            :pictureListOption="pictureListOption"
            :mobilePictureListOption="mobilePictureListOption"
            :rawDot="true"
            @updateVideoPlay="updateVideoPlay"
            :getBannerStyle="getBannerStyle"
        >
            <div class="layout14-container f-col" :class="[searchBarLayout]">
                <media-content
                    :align="searchBarLayout"
                    :title="title"
                    :subTitle="subTitle"
                    :showShadow="showShadow"
                    v-animated="textAnimation"
                >
                    <banner-button :buttons="buttons" :fitWidth="true" />
                </media-content>

                <div v-if="pictureList.length" class="pictureList" v-animated="pictureAnimation">
                    <div
                        class="pictureItem"
                        v-for="(picture, index) in pictureList"
                        :key="index"
                    >
                        <!-- @click="touched(index, $event)" -->
                        <a :href="picture?.linkUrl">
                            <site-img
                                v-if="picture.imgUrl"
                                class="item-img"
                                :size="300"
                                :src="picture.imgUrl"
                                :alt="picture.alt || imgAlt"
                            />
                            <div v-else class="defalt-img hero-default">
                                <site-img :size="300" :src="defaultImgSrc" dir="width" />
                            </div>
                        </a>
                    </div>
                </div>
                <div v-if="pictureList.length == 0 && inCms" class="pictureList pictureList-empty">
                    <div
                        class="pictureItem"
                        v-for="i in 3"
                        :key="i"
                    >
                        <div class="defalt-img hero-default">
                            <site-img :size="300" :src="defaultImgSrc" dir="width" />
                        </div>
                    </div>
                </div>
                <PSwp
                    :options="photoswipeOption"
                    ref="pswp"
                    defaultSize="1000x600"
                />
            </div>
        </banner>
    </div>
</template>

<script>
import util from '@/common/util';
import common from '../index.js';
import MediaContentV2 from '../../../components/media-content-v2.vue';
import BannerButtonV2 from '../../../components/banner-button-v2.vue';
import PSwp from '../../../components/pswp.vue';
export default {
    mixins: [common],
    components: {
        MediaContent: MediaContentV2,
        BannerButton: BannerButtonV2,
        PSwp
    },
    data: function() {
        return {
            isVideoPlay: false,
            defaultImgSrc: 'https://cdn.chime.me/image/fs/sitebuild/site-cms/default-img.png',
            photoswipeOption: {},
        };
    },
    computed: {
        textAnimation() {
            return {
                name: this.isMobileSize ? 'shift-right' : (this.searchBarLayout == 'right' ? 'shift-left' : 'shift-right'),
                enable: this.showAnimationEffects
            }
        },
        pictureAnimation() {
            return {
                name: this.isMobileSize ? 'shift-right' : (this.searchBarLayout == 'right' ? 'shift-right' : 'shift-left'),
                enable: this.showAnimationEffects
            }
        },
        boxTranslate() {
            return (
                (this.isMobileSize
                    ? this.mobileBtmSpacing / 2
                    : this.btmSpacing / 2) + 'px'
            );
        },
        pictureList() {
            let list = [];
            if (this.isMobileSize) {
                list =
                        this.showcaseImages?.mobileList &&
                        this.showcaseImages?.mobileList.length > 0
                            ? this.showcaseImages?.mobileList
                            : this.showcaseImages?.list;
            } else {
                list =
                    this.showcaseImages?.list &&
                    this.showcaseImages?.list.length > 0
                        ? this.showcaseImages?.list
                        : this.showcaseImages?.mobileList;
            }
            return (list || []).map(item => {
                if (typeof item.imgUrl === 'object') {
                    return { ...item, ...item.imgUrl };
                }
                return item;
            });
        },
        inCms() {
            return util.inCms;
        }
    },
    methods: {
        getBannerStyle({ offsetTop, autoHeight, type, isMobileSize, BANNER_TYPE }) {
            if (this.sizeOption.type == BANNER_TYPE.fullScreen) {
                if (this.isMobileSize) {
                    return { minHeight: window.innerHeight - 62 }
                } else {
                    let minHeight = Math.max(
                        window.innerHeight - offsetTop,
                        800
                    ); 
                    return { minHeight: Math.max(minHeight, autoHeight) }
                }    
            }
        },
        updateVideoPlay(flag) {
            this.isVideoPlay = flag;
        },
        touched(index, $event) {
            this.photoswipeOption.images = this.pictureList.map(
                item => item.imgUrl
            );
            this.photoswipeOption.elems =
                this.$el.querySelectorAll('.pictureList img');
            this.photoswipeOption.swiperNum = this.pictureList.length;
            this.$refs.pswp.openPhotoSwipe(index, $event.target);
        }
    },
};
</script>

<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-hero.layout14 {
    .banner {
        align-items: flex-end;
        padding: 0;
    }
    .layout14-container {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        gap: 50px;
        padding: 80px 0;
    }

    .media-content-v2 {
        width: calc((100% - 50px) / 2);
        align-items: flex-start;
        .media-info {
            width: 100%;
            .title-text {
                display: flex;
                flex-direction: column-reverse;
                align-items: flex-start;
                .site-subtitle{
                    margin-bottom: 10px;
                    font-family: var(--font-normal);
                }
            }
        }
    }
    .banner-button-v2 {
        width: 100%;
        margin-top: 40px;
        justify-content: flex-start;
        column-gap: 20px;
        row-gap: 20px;
        .btn-item{
            font-size: 16px;
            margin: 0;
            min-width: 240px;
            max-width: 390px;
            width: var(--sync-button-width);
            height: 50px;
            line-height: 50px;
        }

        @include media-1080 {
            width: 100%;
            .btn-item {
                max-width: 100%;
                width: calc((100% - 20px) / 2);
            }
        }
    }

    .pictureList {
        width: calc((100% - 50px) / 2);
        height: 140px;
        position: relative;
        z-index: var(--level-sublow);
        display: flex;
        justify-content: flex-end;
        gap: 15px;
        .pictureItem {
            width: calc((100% - 30px) / 3);
            height: 100%;
            overflow: hidden;
            cursor: pointer;
            a {
                display: block;
                width: 100%;
                height: 100%;
                cursor: pointer;
            }
            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                vertical-align: middle;
                transition: transform 0.3s ease;
            }
            &:hover {
                img {
                    transform: scale(1.1);
                }
            }
            .defalt-img {
                width: 100%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                background: rgba(218, 218, 218, 0.8);
                img {
                    width: 40px;
                    height: 35px;
                    @include media-800 {
                        width: 30px;
                        height: 26.25px;
                    }
                }
            }
        }
    }

    .video-box video {
        object-fit: cover;
    }
    .banner-video {
        .title-text .media-shadow {
            display: none;
        }
        .play-video {
            width: 64px;
            height: 64px;
            border: 1px solid white;
            pointer-events: all;
            &:after {
                content: "";
                position: absolute;
                top: 50%;
                left: 26px;
                transform: translateY(-50%);
                border-top: 8px solid transparent;
                border-bottom: 8px solid transparent;
                border-left: 14px solid white;
            }
            @include media-800 {
                width: 40px;
                height: 40px;
                &:after {
                    left: 15px;
                    border-top: 5px solid transparent;
                    border-bottom: 5px solid transparent;
                    border-left: 10px solid white;
                }
            }
        }
        .video-loading {
            display: none;
            margin: 0 auto;
            width: 64px;
            height: 64px;
            background: url(//static.chimeroi.com/site/images/home/loading.gif) no-repeat;
            background-size: cover;
            @include media-800 {
                width: 40px;
                height: 40px;
            }
        }
        &.auto-height {
            .video-box video {
                object-fit: contain;
            }
        }
    }
    .banner-video.autoplay,
    .banner-video.is-play {
        .video-loading {
            display: none;
        }
        .play-video {
            display: none;
        }
    }
    .banner-video.loading {
        .video-loading {
            display: block;
        }
        .play-video {
            display: none;
        }
    }

    .layout14-container {
        &.right {
            flex-direction: row-reverse;
            .media-content-v2 {
                align-items: flex-end;
                .media-info {
                    .title-text {
                        align-items: flex-end;
                    }
                }
            }
            .banner-button-v2 {
               justify-content: flex-end; 
            }

            .pictureList {
                justify-content: flex-start;
            }
        }
        &.column {
            flex-direction: column;
            gap: 150px;
            padding: 40px 0;

            @include media-800 {
                .pictureList {
                    justify-content: flex-start;
                }
            }
        }
    }

     @media (max-width: 900px) {
        .layout14-container {
            flex-direction: column;
            gap: 150px;
            padding: 40px 0;
        }
        .media-content-v2 {
            width: 100%;
        }
        .banner-button-v2 {
            width: 100%;
            column-gap: 15px;
            row-gap: 20px;
            .btn-item{
                width: calc((100% - 15px) / 2);
            }
        }

        .pictureList {
            width: 100%;
            height: 80px;
            gap: 8px;
            .pictureItem {
                width: calc((100% - 16px) / 3);
            }
        }

        .banner-video {
            .play-video {
                top: auto;
                bottom: 155px;
            }
        }
    }
}
</style>
